/**
 * Belgian province helpers for tarif availability display.
 *
 * Imported from the Excel tarif sheet (column block "DISPONIBILITÉ PAR PROVINCE").
 * The 11 codes match the ones the importer writes into
 * outil_facturation_tarifs.available_provinces.
 */

export const PROVINCE_BRU = 'BRU' as const;
export const WAL_PROVINCES = ['BW', 'HT', 'LG', 'LX', 'NA'] as const;
export const VLA_PROVINCES = ['AN', 'BF', 'FO', 'FOR', 'LI'] as const;

export const PROVINCE_LABELS: Record<string, string> = {
  // Aggregated regions
  BRU: 'Bruxelles',
  WAL: 'Wallonie',
  VLA: 'Flandre',
  // Wallonia
  BW:  'Brabant wallon',
  HT:  'Hainaut',
  LG:  'Liège',
  LX:  'Luxembourg',
  NA:  'Namur',
  // Flanders
  AN:  'Anvers',
  BF:  'Brabant flamand',
  FO:  'Flandre occidentale',
  FOR: 'Flandre orientale',
  LI:  'Limbourg',
};

/**
 * Aggregate province codes for display:
 *   - all 5 Walloon provinces present → collapsed to single 'WAL'
 *   - all 5 Flemish provinces present → collapsed to single 'VLA'
 *   - BRU kept as-is
 *   - partial Wal/Vla → individual codes kept
 *
 * Output order: BRU, then Wal (region or individual codes), then Vla.
 */
export function aggregateProvinces(codes: readonly string[]): string[] {
  const set = new Set(codes);
  const out: string[] = [];

  if (set.has(PROVINCE_BRU)) out.push(PROVINCE_BRU);

  if (WAL_PROVINCES.every(c => set.has(c))) {
    out.push('WAL');
  } else {
    WAL_PROVINCES.forEach(c => { if (set.has(c)) out.push(c); });
  }

  if (VLA_PROVINCES.every(c => set.has(c))) {
    out.push('VLA');
  } else {
    VLA_PROVINCES.forEach(c => { if (set.has(c)) out.push(c); });
  }

  return out;
}

export function provinceLabel(code: string): string {
  return PROVINCE_LABELS[code] || code;
}
